<div id="app-total-statistic">
    <table class="table table-bordered">
        <tr class="stat-header">
            <td colspan="3">{{'forms.common.Overall evaluation of the criteria' | translate}}</td>
        </tr>
        <tr>
            <td colspan="2">
                <ng-container *ngIf="process?.hasEvaluationItems;else totalEvaluationCriteria">
                    {{'forms.common.The total quality levels assessment' | translate}}
                </ng-container>
                <ng-template #totalEvaluationCriteria>
                    {{'forms.common.The total evaluation criteria' | translate}}
                </ng-template>
            </td>
            <td width="35%">{{category.totalEvaluationCriteria | number : '1.1-1'}}</td>
        </tr>
        <tr>
            <td colspan="2">
                <ng-container *ngIf="process?.hasEvaluationItems;else numberOfApplicable">
                    {{'forms.common.The number of applicable quality levels' | translate}}
                </ng-container>
                <ng-template #numberOfApplicable>
                    {{'forms.common.The number of applicable criteria' | translate}}
                </ng-template>
            </td>
            <td>{{category.numberOfApplicable}}</td>
        </tr>
        <tr>
            <td colspan="2">{{'forms.common.Average Rating Criterion' | translate}}</td>
            <td>{{category.calculatedSavedScore | number : '1.1-1'}}</td>
        </tr>
        <tr>
            <td colspan="2">{{'forms.common.The overall evaluation score of the standard' | translate}}</td>
            <td class="answer-scroe">
                <span>
                    {{category.calculatedSavedScore | number : '1.1-1'}} {{'forms.common.points' | translate}} -
                    {{category.evaluationScoreMessage}}
                </span>
            </td>
        </tr>
    </table>
</div>